import _ from "lodash"
import { Query } from "../query"

class PermissionsImpl {
  apis: any

  registrations: any[]
  filteredRegistrations: any[]

  public async initialize(apis) {
    this.apis = apis
    const collection = new Query(apis)
      .setEntityType('/1.0/entities/metadata/core_yms_schedulerAccessRegistration.json')
      .setDebug({ context: 'model--Permissions' })
      .getCollection()
    return collection.find().then(entities => {
      this.registrations = entities
    }).finally(() => {
      collection.dispose()
    })
  }

  public getAll() {
    const filteredRegistrations = this.filteredRegistrations

    if (filteredRegistrations) {
      return filteredRegistrations
    }

    // n.b. it's not possible to filter during initialization because we load rules at the same time we load the user
    this.filteredRegistrations = _.filter(this.registrations, r => r.core_yms_schedulerAccessRegistration.user.entityId === this.apis.getSettings().getUser().uniqueId)
    return this.filteredRegistrations
  }
}

const permissions = new PermissionsImpl()
export default permissions
